import {AccountFavoritesContext} from "../../contexts/Account/AccountFavoritesContext.tsx";
import {ReactNode, useCallback, useState} from "react";
import {IFavorite} from "../../interfaces/account/favorite/IFavorite.ts";
import axios from "axios";
import apiNet from "../../newApi/apiNet.ts";
import {NotificationStatus} from "../../components/notification/Notification.tsx";
import {useNotification} from "../NotificationProvider.tsx";
import {IError} from "../../interfaces/IError.ts";
import {FavoriteTypeTypes} from "../../types/account/favoriteTypeTypes.ts";
import {AddFavoriteRequest} from "../../request/account/addFavoriteRequest.ts";

interface IProps {
    children: ReactNode;
}

const AccountFavoritesProvider = ({children}: IProps) => {
    const {showNotification} = useNotification();
    const [favorites, setFavorites] = useState<IFavorite[]>([]);
    const updateAll = useCallback((favorites: IFavorite[]) => {
        setFavorites(favorites);
    }, []);

    const getAll = useCallback(async () => {
        try {
            const result = await apiNet.getFavorites();
            setFavorites(result.data);
        } catch (e) {
            showNotification("Niepowodzenie", "Wystąpił problem podczas pobierania danych. Proszę spróbować ponownie za kilka minut.", NotificationStatus.failure);
        }
    }, [showNotification]);

    const deleteFavorite = useCallback(async (id: string) => {
        try {

            await apiNet.deleteFavorite(id);

            setFavorites(prev => ({
                ...prev,
                recordings: prev.filter(r => r.id !== id) ?? [],
            }));

            showNotification("Sukces", "Nagranie zostało usunięte", NotificationStatus.success);
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const message = e.response?.data?.message ?? "Błąd podczas usuwania nagrania";
                showNotification("Błąd API", message, NotificationStatus.failure);
            } else {
                showNotification("Niepowodzenie", "", NotificationStatus.failure);
            }
        }
    }, [showNotification]);

    const add = useCallback(async (name: string, searchQuery: string, type: FavoriteTypeTypes) => {
        try {
            const newFavorite: AddFavoriteRequest = {name, searchQuery, type};
            await apiNet.addFavorite(newFavorite);
            setFavorites(prevState => ({...prevState, newFavorite}));
            showNotification("Sukces", "Element zostal pomyslnie dodany do ulbuionych.", NotificationStatus.failure);

        } catch (e) {
            if (axios.isAxiosError(e)) {
                const error = e.response?.data() as IError;
                if (e.response?.status == 400) {
                    if (error.MsgCode == "FAVORITE_NAME_ALREADY_EXISTS") {
                        showNotification("Niepowdzenie", "Element już istnieje.", NotificationStatus.failure);
                    }
                } else {
                    showNotification("Niepowdzenie", "Wystąpił błąd po stronie serwera. Proszę spróbować ponownie za kilka minut.", NotificationStatus.failure);
                }
            }
        }
    }, [showNotification]);


    return (
        <AccountFavoritesContext.Provider value={{favorites, updateAll, getAll, deleteFavorite: deleteFavorite, add}}>
            {children}
        </AccountFavoritesContext.Provider>
    );
};

export default AccountFavoritesProvider;